document.addEventListener("DOMContentLoaded", function () {

    document.querySelectorAll('[data-oembed-url]').forEach(function (element) {
        element.onclick = function () {
            const url = element.getAttribute('data-oembed-url');
            const iframe = document.createElement('iframe');

            iframe.src = url;
            iframe.width = '100%';
            iframe.height = '300px';
            iframe.setAttribute('frameborder', '0');
            iframe.setAttribute('allowfullscreen', '');
            element.parentElement.appendChild(iframe);

            element.remove();
        };

    });

});